import { Column, Entity } from "typeorm";
import { CommonColumns } from '../../../../common-columns.entity';

@Entity('dl_wh_date_change_log')
export class DLWhDateChangeLogEntity extends CommonColumns {

    @Column('varchar', { name: "production_plan_id", length: 14 })
    productionPlanId: string;

    @Column({ type: 'date', name: 'prev_wh_date', nullable: true })
    prevWhDate: Date;

    @Column({ type: 'date', name: 'current_wh_date', nullable: true })
    currentWhDate: Date;
}